import * as contentful from "contentful"
import config from "../config"

export default contentful.createClient({
  space: config.GATSBY_CONTENTFUL_SPACE_ID,
  accessToken: config.GATSBY_CONTENTFUL_ACCESS_TOKEN,
  host: config.GATSBY_CONTENTFUL_HOST,
})
